module.exports = __webpack_public_path__ + "f965f663fe8bdec49143eaa8c4ac7c74.svg";